'use client';

import { createContext, PropsWithChildren, useContext } from 'react';

type LayoutContextData = {
  content: LayoutContent;
};

const LayoutContext = createContext({} as LayoutContextData);

export type LayoutContextProviderProps = PropsWithChildren<{
  content: LayoutContent;
}>;

export function LayoutContextProvider({
  children,
  content,
}: LayoutContextProviderProps) {
  return (
    <LayoutContext.Provider value={{ content }}>
      {children}
    </LayoutContext.Provider>
  );
}

export function useLayout() {
  const context = useContext(LayoutContext);

  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }

  return context;
}
